import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';
import type Civilite from '../../interfaces/tiers/Civilite';

const getCivilites = () =>
	request.get<unknown, TemplateRequestGet<Civilite>>(
		'/api/transverse/civilites?all=true&caduque=false',
	);

export default getCivilites;
